'use client';

import { c as _c } from "react/compiler-runtime";
import { ChartNoDataEmptyState } from '@/comps/charts/analytics-chart/ChartNoDataEmptyState';
import { Button } from '@/comps/primitives/button';
import { CHART_EMPTY_ERROR_DESCRIPTION, CHART_EMPTY_ERROR_TITLE } from '@/constants/misc.constants';
import { SpendByModelChart } from '@/domains/pages/ai-spend/components/spend-by-model-chart';
import { SpendModelLegend } from '@/domains/pages/ai-spend/components/spend-model-legend';
import { SPEND_BY_MODEL_CARD_TITLE, SPEND_BY_MODEL_CARD_TOOLTIP, SPEND_BY_MODEL_HEADER_TITLE_CHIP_CLASS, SPEND_BY_MODEL_HEADER_TITLE_CLASS, SPEND_BY_MODEL_HEADER_TOOLBAR_CLASS, SPEND_BY_MODEL_HEADER_TRAILING_CLASS, SPEND_BY_MODEL_CHART_MIN_HEIGHT_CLASS, SPEND_BY_MODEL_EMPTY_TITLE } from '@/domains/pages/ai-spend/constants';
import type { TaskModelSeries } from '@/domains/pages/ai-spend/utils/map-ai-spend-task-model';
import { NebulyPageCard } from '@/domains/pages/shared/nebuly-page-card';
import { cn } from '@/utils/shad';
type SpendByModelCardProps = {
  taskLabels: string[];
  series: TaskModelSeries[];
  isLoading?: boolean;
  isError?: boolean;
  onRetry?: () => void;
  className?: string;
};
export function SpendByModelCard(t0) {
  const $ = _c(16);
  const {
    taskLabels,
    series,
    isLoading: t1,
    isError: t2,
    onRetry,
    className
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isError = t2 === undefined ? false : t2;
  const hasSeries = series.length > 0;
  let t3;
  if ($[0] !== isLoading || $[1] !== series) {
    t3 = isLoading ? null : <SpendModelLegend series={series} />;
    $[0] = isLoading;
    $[1] = series;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = cn("min-h-0", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hasSeries || $[6] !== isError || $[7] !== isLoading || $[8] !== onRetry || $[9] !== series || $[10] !== taskLabels) {
    t5 = isError ? <div className="flex flex-col items-start" data-testid="spend-by-model-error-state"><ChartNoDataEmptyState title={CHART_EMPTY_ERROR_TITLE} description={CHART_EMPTY_ERROR_DESCRIPTION} className="py-8" />{onRetry ? <Button variant="defaultDark" size="sm" className="mb-8 ml-8 h-8 rounded-full px-4 text-xs" onClick={onRetry}>Try again</Button> : null}</div> : isLoading ? <div className={cn("w-full", SPEND_BY_MODEL_CHART_MIN_HEIGHT_CLASS)} /> : hasSeries ? <SpendByModelChart taskLabels={taskLabels} series={series} /> : <div data-testid="spend-by-model-empty-state"><ChartNoDataEmptyState title={SPEND_BY_MODEL_EMPTY_TITLE} description="" className="py-8" /></div>;
    $[5] = hasSeries;
    $[6] = isError;
    $[7] = isLoading;
    $[8] = onRetry;
    $[9] = series;
    $[10] = taskLabels;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <NebulyPageCard title={SPEND_BY_MODEL_CARD_TITLE} description={SPEND_BY_MODEL_CARD_TOOLTIP} headerTrailing={t3} headerTitleClassName={SPEND_BY_MODEL_HEADER_TITLE_CLASS} titleChipClassName={SPEND_BY_MODEL_HEADER_TITLE_CHIP_CLASS} headerToolbarClassName={SPEND_BY_MODEL_HEADER_TOOLBAR_CLASS} headerTrailingClassName={SPEND_BY_MODEL_HEADER_TRAILING_CLASS} className={t4} contentClassName="flex flex-col gap-4 !py-4" testId="spend-by-model-card">{t5}</NebulyPageCard>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}